import React from 'react';
import Typography from '@material-ui/core/Typography';
import { NotificationManager } from 'react-notifications';
import LoggedInContainer from '../../components/loggedInContainer/loggedInContainer';
import OrdersList from '../../components/ordersList/ordersList';
import http from '../../services/http';

import './myOrders.less';

class MyOrdersPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
    };

    this.fetchOrders();
  }

  fetchOrders = async () => {
    try {
      const { items } = await http.post('/api/client/getmyorders', {
        Page: {
          PageIndex: 0,
          PageSize: 10000,
        },
      });

      this.setState({ orders: items });
    } catch {
      NotificationManager.error('Nie udało się pobrać zamówień!', 'Błąd', 5000);
    }
  }

  render() {
    const { orders } = this.state;

    return (
      <LoggedInContainer>
        <div className="page-title">
          <Typography variant="h5">
            Moje zamówienia
          </Typography>
        </div>

        <OrdersList
          orders={orders}
          adminMode={false}
        />
      </LoggedInContainer>
    );
  }
}

export default MyOrdersPage;
